import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col h-[100dvh] w-full items-center justify-start overflow-auto px-4 pt-10 pb-20 lg:p-32 gap-8">
      <div className="flex flex-col w-full gap-8 max-w-[600px]">

        <div className="flex flex-col gap-3">
          <h1 className="font-heading font-bold text-[24px] text-ink tracking-tight">Privacy Policy</h1>
          <div className="font-body text-[15px] text-ink">Effective February 20, 2026</div>
        </div>

        <div className="flex flex-col gap-8 tracking-tight leading-tight w-full">

          <div className="flex flex-col gap-3">
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>Worldlines Technology ("Worldlines," "we," "us," or "our") operates the website worldlines.tech and related services. This Privacy Policy explains what information we collect, how we use it, and your choices regarding that information.</p>
              <p>We believe in minimal data collection. We collect only what is necessary to operate and improve our services.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">1. Information We Collect</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p className="font-heading font-bold">Information you provide directly</p>
              <p>If you contact us by email or through any form on our website, we collect the information you provide, such as your name, email address, and the content of your message.</p>
              <p className="font-heading font-bold">Information collected automatically</p>
              <p>When you visit our website, we may automatically collect certain technical information, including your IP address, browser type, operating system, referring URL, pages visited, and the date and time of your visit. We use this information to understand how our website is used and to improve it.</p>
              <p>We do not use third-party advertising trackers. We do not sell your data.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">2. How We Use Your Information</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>We use collected information to:</p>
              <ul className="list-disc pl-5 flex flex-col gap-2">
                <li>Operate, maintain, and improve our website and services</li>
                <li>Respond to your inquiries and communications</li>
                <li>Analyze usage patterns to improve user experience</li>
                <li>Comply with legal obligations</li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">3. Data Sharing</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>We do not sell, rent, or trade your personal information to third parties. We may share information only in the following circumstances:</p>
              <ul className="list-disc pl-5 flex flex-col gap-2">
                <li>With service providers who assist us in operating our website (e.g., hosting), subject to confidentiality obligations</li>
                <li>When required by law, regulation, or legal process</li>
                <li>To protect the rights, property, or safety of Worldlines, our users, or the public</li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">4. Cookies</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>Our website may use essential cookies required for basic site functionality. We do not use cookies for advertising or cross-site tracking. You can configure your browser to refuse cookies, though this may affect your ability to use certain features of our website.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">5. Data Retention</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>We retain personal information only for as long as necessary to fulfill the purposes described in this policy, or as required by law. Automatically collected technical data is retained in aggregate form and is not linked to individual identities.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">6. Security</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>We implement reasonable technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction. No method of transmission over the internet is completely secure, and we cannot guarantee absolute security.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">7. Your Rights</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>Depending on your jurisdiction, you may have the right to:</p>
              <ul className="list-disc pl-5 flex flex-col gap-2">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your personal information</li>
                <li>Object to or restrict certain processing of your information</li>
              </ul>
              <p>To exercise any of these rights, please contact us at the address below.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">8. Children's Privacy</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>Our services are not directed at individuals under the age of 13. We do not knowingly collect personal information from children. If we become aware that we have collected information from a child under 13, we will take steps to delete it promptly.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">9. Changes to This Policy</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date. Your continued use of our website after any changes constitutes acceptance of the updated policy.</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-heading font-bold text-[20px] text-ink">10. Contact</div>
            <div className="font-body text-[15px] text-ink flex flex-col gap-4">
              <p>If you have questions about this Privacy Policy or wish to exercise your rights, please contact us at:</p>
              <p>Worldlines Technology<br />privacy@worldlines.tech</p>
            </div>
          </div>

        </div>

        <div className="flex flex-col items-center justify-center gap-5 pt-8">
          <div className="flex gap-8">
            <Link to="/" className="font-body text-[15px] text-ink hover:underline no-underline">Home</Link>
            <Link to="/privacy" className="font-body text-[15px] text-ink hover:underline no-underline">Privacy policy</Link>
            <Link to="/terms" className="font-body text-[15px] text-ink hover:underline no-underline">Terms of use</Link>
          </div>
          <div className="font-body text-[15px] text-ink">©2026 Worldlines Technology</div>
        </div>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
